import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/_services/auth.service';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    loggingIn = false;
    loading = false;
    submitted = false;
    hidePassword = true;
    loginForm: FormGroup;

    error = false;
    errorText = '';

    constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private authService: AuthService) {}

    ngOnInit() {
        this.loginForm = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]],
        });
    }

    get usernameControl(): AbstractControl {
        return this.loginForm.get('username');
    }

    get passwordControl(): AbstractControl {
        return this.loginForm.get('password');
    }

    get username(): string {
        return this.usernameControl.value;
    }

    get password(): string {
        return this.passwordControl.value;
    }

    login() {
        const self = this;
        self.submitted = true;

        // stop here if form is invalid
        if (self.loginForm.invalid) {
            return;
        }

        self.loggingIn = true;
        self.loading = true;
        self.error = false;
        self.errorText = '';

        self.authService
            .Login(self.username, self.password)
            .pipe(first())
            .subscribe(
                (userInfo) => {
                    // userInfo contains the user information. Store it via the user service.
                    self.authService.ProcessLogin(userInfo);

                    // get return url from query parameters or default to home page
                    const returnUrl = self.route.snapshot.queryParams['returnUrl'] || '/';
                    self.router.navigateByUrl(returnUrl);
                },
                (error: HttpErrorResponse) => {
                    self.errorText =
                        error.status == 401
                            ? 'Invalid username and password.'
                            : 'Server error, please contact the site administrator.';
                            
                    self.error = true;
                    self.loggingIn = false;
                    self.loading = false;
                }
            );
    }
}
